/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)

 * Licensed Under MIT (http://opensource.org/licenses/MIT)
 *
 * React File Base64 - Version@1.0.0
 *
 */

import fileBase64Styles from './fileBase64.module.scss'

import React from 'react'

export default class FileBase64 extends React.Component {
   constructor(props) {
      super(props)
      this.state = {
         files: [],
         errorFiles: [],
      }
   }

   handleChange(e) {
      // get the files
      let files = e.target.files

      // Process each file
      const allFiles = []
      const errorFiles = []

      for (var i = 0; i < files.length; i++) {
         let file = files[i]

         // Make new FileReader
         let reader = new FileReader()

         // Convert the file to base64 text
         reader.readAsDataURL(file)

         // on reader load somthing...
         reader.onload = () => {
            // Make a fileInfo Object
            let fileInfo = {
               name: file.name,
               type: file.type,
               size: Math.round(file.size / 1000) + ' kB',
               weight: file.size,
               base64: reader.result,
               file: file,
            }

            const maxfilesize = this.props.maxfilesize || 1024 * (1024 * 1)

            // Push it to the state
            file.size < maxfilesize
               ? allFiles.push(fileInfo)
               : errorFiles.push(fileInfo)

            this.setState({ errorFiles: [...errorFiles], files: [...allFiles] })

            // If all files have been proceed
            if (allFiles.length === files.length) {
               // Apply Callback function
               if (this.props.multiple)
                  this.props.ondone(allFiles, this.props.maxfilesize)
               else this.props.ondone(allFiles[0], this.props.maxfilesize)
            }
         } // reader.onload
      } // for
   }

   render() {
      //console.log(this.state, this.props.maxfilesize)
      const { errorFiles } = this.state
      return (
         <React.Fragment>
            <input
               className={`${
                  this.props.showRequiredLine ? fileBase64Styles.required : ''
               }`}
               type='file'
               onChange={this.handleChange.bind(this)}
               multiple={this.props.multiple}
               {...this.props}
            />
            <div className={fileBase64Styles.validate}>
               <span
                  className={
                     errorFiles.length > 0
                        ? fileBase64Styles.alert
                        : fileBase64Styles.message
                  }
               >
                  {errorFiles.length > 0
                     ? 'Error, image(s) exceed the valid size (Max. 500kb):  '
                     : 'Max. file size per image 500kb'}
               </span>
               <ul>
                  {this.state.errorFiles.map((val, i) => (
                     <lo>
                        {i + 1}.- File name: {val.name}, File size {val.size}
                     </lo>
                  ))}
               </ul>
            </div>
         </React.Fragment>
      )
   }
}

FileBase64.defaultProps = {
   multiple: false,
}
